export default __webpack_public_path__ + "static/media/material-symbols-light_money-bag.9becfb99.svg";